import React from "react"
import { Form, Button } from "semantic-ui-react"

export default class NotesTab extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.defaultState()
  }

  defaultState = () => {
    return {
      isEditing: false,
      internalNotes: this.props.internalNotes || ""
    }
  }

  toggleEdit = () => this.setState({ isEditing: !this.state.isEditing })

  handleCancel = () => {
    this.setState(this.defaultState())
  }

  onSubmit = () => {
    const { internalNotes } = this.state
    const params = { internal_notes: internalNotes }
    this.props.updateOrder(params)
  }

  render() {
    const { isEditing, internalNotes } = this.state
    const marginTop = { marginTop: "15px" }

    return (
      <React.Fragment>
        <h4>Notes:</h4>
        {!isEditing &&
          <div>
            {[null, undefined, ""].includes(internalNotes) ?
              <div><em>No notes</em></div> :
              <div style={{"white-space": "pre-wrap"}}>{internalNotes}</div>
            }
            <div style={marginTop}>
              <Button primary type="button" onClick={this.toggleEdit}>Edit</Button>
            </div>
          </div>
        }
        {isEditing &&
          <Form onSubmit={this.onSubmit}>
            <div style={marginTop}>
              <textarea
                value={internalNotes}
                rows="10"
                onChange={(e) => this.setState({ internalNotes: e.target.value })}
              />
            </div>
            <div style={marginTop}>
              <Button primary type="submit" value="Filter">Save</Button>
              <Button secondary type="button" value="Filter" onClick={this.handleCancel}>
                Cancel
              </Button>
            </div>
          </Form>
        }
      </React.Fragment>
    )
  }
}
